import { render, staticRenderFns } from "./AddTerm.vue?vue&type=template&id=2e2e7de8&"
import script from "./AddTerm.vue?vue&type=script&lang=js&"
export * from "./AddTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports